import { render, staticRenderFns } from "./Bando31Fase1.vue?vue&type=template&id=c8b80cd8&scoped=true"
import script from "./Bando31Fase1.vue?vue&type=script&lang=js"
export * from "./Bando31Fase1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b80cd8",
  null
  
)

export default component.exports